export const formatPasswordPolicyErrors = (errors) => errors.join(" ");
//# sourceMappingURL=formatters.js.map